import styled from 'styled-components';

export const ContainerCarne = styled.div`
  margin: 0px 24px;
  input {
    font-size: 1.2rem;
    padding: 0.25rem 0.5rem;
  }
`;

export const InputFake = styled.div`
  font-size: 1rem;
  padding: 0.2rem 1rem 0.2rem 0.25rem;
  border: 1px solid #000;

  display: inline-block;
`;

export const ContainerContrato = styled.div`
  margin: 24px;
  font-size: 1rem;
  line-height: 1.5;
  p {
    margin-bottom: 1rem;
  }
`;

export const PageBreak = styled.p`
  clear: both;
  display: block;
  margin: 0;
  height: 1px;
  width: 100%;
  page-break-after: always;
`;

export const PalcoBarCode = styled.div`
  display: flex;
  align-items: center;
  max-width: 520px;
  height: 83px;
  svg {
  }
`;
